import React from "react";
import ReactTable from "react-table";
import matchSorter from 'match-sorter';
import { keys } from "lodash";

class DeliveryAgregarCliente extends React.Component {

    constructor(props){
        super(props)
        this.state = {
            localFormValues: {
                NroDocumento: '',
                RazonSocial: '',
                celular: '',
                direccion: '',
                referencia: ''
            },
            dataDirecciones: [
                {
                    IdDireccion: 1,
                    Direccion: "Jr. San Salvador 520",
                    Referencia: "A media cuadra de iglesia Mormones"
                },
                {
                    IdDireccion: 2,
                    Direccion: "Jr. San Pedro 520",
                    Referencia: "A media cuadra de iglesia San Pedro"
                }
            ]
        }
    }

    static getDerivedStateFromProps(nextProps, prevState) {
        if (nextProps.formValues) {
            return {
                localFormValues: {
                    ...prevState.localFormValues,
                    ...nextProps.formValues
                }
            };
        }
        return null;
    }

    handleLocalChange = (e) => {
        const { name, value } = e.target;
        
        if (this.props.onChange) {
            this.props.onChange(e);
        } else {
            this.setState(prevState => ({
                localFormValues: {
                    ...prevState.localFormValues,
                    [name]: value
                }
            }));
        }
    }

    render() {
        const formValues = this.props.formValues || this.state.localFormValues;
        const nroTipoDocumento = formValues.NroDocumento || '';
        const direccion = formValues.direccion || '';
        const razonSocial = formValues.RazonSocial || '';
        const celular = formValues.celular || '';
        const referencia = formValues.referencia || '';

        const onChangeHandler = this.props.onChange || this.handleLocalChange;

        return(
            <div>
                <React.Fragment>
                    <div className="container mt-3 mb-3">
                        <div className="abed__newcliente-header">
                            <div className="col-12 mb-2">
                                <label>RUC/DNI</label>
                                <div className="input-group mb-3">
                                    <input 
                                        autoFocus 
                                        onChange={onChangeHandler}
                                        className="abed__form-control_input" 
                                        name="NroDocumento"
                                        value={nroTipoDocumento}
                                        style={{width:"69%"}}
                                    />
                                    <button 
                                        type="button" 
                                        className="btn abed__btn-verde-mfp"
                                        onClick={this.props.onSubmitDNI}
                                    >
                                        Buscar
                                    </button>
                                </div>
                            </div>
                            <div className="col-12 mb-2">
                                <label>RAZON SOCIAL</label>
                                <div className="input-group mb-3">
                                    <input 
                                        onChange={onChangeHandler}
                                        className="abed__form-control_input" 
                                        name="RazonSocial"
                                        value={razonSocial}
                                        style={{width:"100%"}}
                                    />
                                </div>
                            </div>
                            <div className="col-12 mb-2">
                                <label>CELULAR</label>
                                <div className="input-group mb-3">
                                    <input 
                                        onChange={onChangeHandler}
                                        className="abed__form-control_input" 
                                        name="celular"
                                        value={celular}
                                        style={{width:"100%"}}
                                    />
                                </div>
                            </div>
                        </div>
                        <div className="abed__newcliente-direccion">
                            <div className="col-12 mb-2">
                                <label>DIRECCION</label>
                                <div className="input-group mb-3">
                                    <input 
                                        onChange={onChangeHandler}
                                        className="abed__form-control_input" 
                                        name="direccion"
                                        value={direccion}
                                        style={{width:"100%"}}
                                    />
                                </div>
                            </div>
                            <div className="col-12 mb-2">
                                <label>REFERENCIA</label>
                                <div className="input-group mb-3">
                                    <input 
                                        onChange={onChangeHandler}
                                        className="abed__form-control_input" 
                                        name="referencia"
                                        value={referencia}
                                        style={{width:"100%"}}
                                    />
                                </div>
                            </div>
                            <div className="col-12 mb-2">
                                <div className="input-group mb-3" style={{minHeight: "24px"}}>
                                    <button 
                                        type="button" 
                                        className="btn abed__btn-verde-mfp"
                                        onClick={this.props.onSubmitDNI}
                                        style={{alignSelf: "flex-end", width:"100%"}}
                                    >
                                        Agregar
                                    </button>
                                </div>
                            </div>
                        </div>
                        <ReactTable
                            data={this.state.dataDirecciones}
                            filterable
                                defaultFilterMethod={(filter, row) => 
                                    String(row[filter.id]).toLowerCase().includes(filter.value.toLowerCase())
                                }
                                columns={[
                                    {
                                        Header: "Acción",
                                        filterable: false,
                                        width: 100,
                                        Cell: row => (
                                            <div>
                                                <button 
                                                    className="btn btn-sm btn-primary mr-1"
                                                    onClick={() => console.log('Editar', row.original)}
                                                >
                                                    Editar
                                                </button>
                                                <button 
                                                    className="btn btn-sm btn-danger"
                                                    onClick={() => console.log('Eliminar', row.original)}
                                                >
                                                    Eliminar
                                                </button>
                                            </div>
                                        )
                                    },
                                    {
                                        Header: "Dirección",
                                        id: "Direccion",
                                        width: 300,
                                        accessor: d => d.Direccion,
                                        filterMethod: (filter, rows) => 
                                            matchSorter(rows, filter.value, {keys: ["Direccion"]}),
                                        filterAll: true
                                    },
                                    {
                                        Header: "Referencia",
                                        id: "Referencia",
                                        width: 300,
                                        accessor: d => d.Referencia,
                                        filterMethod: (filter, rows) => 
                                            matchSorter(rows, filter.value, {keys: ["Referencia"]}),
                                        filterAll: true
                                    }
                                ]}
                                defaultPageSize={5}
                                showPagination={false}
                                className="-striped -highlight"
                                previousText='Anterior'
                                nextText='Siguiente'
                                loadingText='Cargando...'
                                noDataText='No se encontraron direcciones'
                                pageText='Página'
                                ofText='de'
                                rowsText='filas'
                                style={{
                                    fontSize: "14px",
                                    height: "200px",
                                    overflow: "auto"
                                }}
                        />
                    </div>
                </React.Fragment>
            </div>
        )
    }
}

export default DeliveryAgregarCliente;